// extracted by mini-css-extract-plugin
export default {"contentContainer":"companyEditor_contentContainer__fXTtH","buttonBox":"companyEditor_buttonBox__rV0Gg","back":"companyEditor_back__YuYdm"};